import React, { Fragment } from "react";

const FileViewerError = () => {
  return (
    <Fragment>
      <div>
        <p>Please upload a valid file</p>
      </div>
    </Fragment>
  );
};

export default FileViewerError;
